import * as React from 'react';
import ElasticsearchAPIConnector from '@elastic/search-ui-elasticsearch-connector';
import classnames from 'classnames';
import { StandardLayout, CompactLayout } from './layouts';
import { Config, connectorConfig } from '../helper';

export default function FacetedSearchOpenSearchView(props) {
  const {config, trackUrlState = true} = props;
  const {displayOptions, indexes, ViewMode, aggregation} = config;
  const {
    layout,
    showFacetsCount = false,
    stickyNavigation = false,
    hideCategoryLabel = false,
  } = displayOptions;
  const {viewMode} = ViewMode;

  const connector = React.useMemo(() => {
    const host = `${location.protocol}//${location.host}`;
    return new ElasticsearchAPIConnector(
      connectorConfig(host, indexes, aggregation)
    );
  }, [indexes, aggregation]);

  const css = {
    root: classnames({
        ['nv-open-search']: true,
        [`nv-open-search--${layout}-layout`]: true,
        [`nv-open-search--${viewMode}-view-mode`]: true,
        [`nv-open-search--with-facets-counters`]: !!showFacetsCount,
        [`nv-open-search--with-sticky-navigation`]: !!stickyNavigation,
        [`nv-open-search--with-no-category-label`]: !!hideCategoryLabel,
      }
    ),
  }

  if (layout === Config.Layouts.Compact) {
    return <CompactLayout connector={connector} compactMode={config?.compactMode} config={config} css={css} trackUrlState={trackUrlState}/>
  }

  return <StandardLayout connector={connector} config={config} css={css} trackUrlState={trackUrlState}/>;
}
